export default __webpack_public_path__ + "static/media/logo-white.0aa60773.png";